// @flow
import React from 'react';
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import type {DepartmentWithLocation} from "../GUI_COMMON/SUPPORT/MagazineV2";
import ArchiverGuiUtils from "../SUPPORT/ArchiverGuiUtils";

interface BTOCardRowProps {
    orderNumber: number,
    createdBy:Object,
    requestedBy:Object,
    destinedForLocation:DepartmentWithLocation,
    onClick: () => void,
    onCheckChanged?: ()=>void,
    dateStarted: Date,
    showCheckBox?: boolean,
    isChecked?: boolean,
    notes: string,
    allowDelete?: boolean,
    onDeleteClicked?: ()=>void,
    allowShipNow?: boolean,
    onShipNowClicked?: ()=>void,
    showExportButton?: boolean,
    exportClicked?: ()=>void,
    exportIsBusy?: boolean,
    deleteShipIsBusy?: boolean
}

const BTOCardRow: React.FC<BTOCardRowProps> = ({orderNumber,dateStarted,createdBy,requestedBy,
                                        destinedForLocation,notes,showCheckBox,isChecked, onCheckChanged, onClick,
                                        allowDelete, onDeleteClicked, showExportButton, exportClicked, exportIsBusy,
                                               allowShipNow, onShipNowClicked, deleteShipIsBusy}) => {
    function dumpDestination() {
        const l = ArchiverGuiUtils.GetShortLocationStringGivenMagStorageLocation(destinedForLocation);
        return(
            <div>{l}</div>    
        );
    }
    
    function handleCBChanged(e) {
        e.stopPropagation();
        if(onCheckChanged) {
            onCheckChanged(e.target.checked);
        }
    }
    
    function handleCBClicked(e) {
        e.stopPropagation(e);
    }
    
    function handleOnClick(e) {
        e.stopPropagation();
        if(onClick) {
            onClick();
        }
    }
    
    function handleDeleteClicked(e) {
        e.stopPropagation();
        if(onDeleteClicked) {
            onDeleteClicked();
        }
    }
    
    function showCheckboxIfRequired() {
        if(showCheckBox) {
            return <td>
                <input type="checkbox" className="m-2 mr-3 border-bottom" name="retrieval-cb" aria-label="Checkbox" checked={isChecked} 
                       onChange={(e)=>handleCBChanged(e)} onClick={(e)=>handleCBClicked(e)}/>
            </td>
        }
    }
    
    function showExportButtonIfRequired() {
        if(showExportButton) {
            return <td>
                <span onClick={(e) => exportClicked(e)} data-toggle="tooltip" title="Export to CSV">
                    {exportIsBusy?<i className="li-pointer li-fg-primary fa fa-spinner fa-pulse fa-fw"/>
                        :<i className="li-pointer li-fg-primary fa fa-download fa-lg"/>}
                </span>
            </td>
        }
    }
    
    function showDeleteIfAllowed() {
        if(!allowDelete) {
            return null;
        }
        
        let tooltip = "Delete this order";
        if(allowShipNow) { // subtle difference 
            tooltip = "Cancel this order";
        }
        
        return(
            <span onClick={(e) => handleDeleteClicked(e)} data-toggle="tooltip" title={tooltip}>
                <i className="li-pointer li-fg-danger fa fa-times-circle fa-lg"/>
            </span>
        );
    }
    
    function showAllowShipNowIfAllowed() {
        if(!allowShipNow) {
            return null;
        }
        
        // NOTE the '/' prefix below as this follows the delete icon
        return(
            <span onClick={(e) => onShipNowClicked(e)} data-toggle="tooltip" title="Ship Now">
                /<i className="li-pointer li-fg-success fa fa-check-circle fa-lg ml-1"/>
            </span>
        );
    }
    
    return (
            <tr>
                {showCheckboxIfRequired()}
                <td className="text-nowrap"><span className="btn-link li-pointer mr-2" onClick={(e)=>handleOnClick(e)}>
                    {LIUtils.prettyOrderNumber(orderNumber)}</span>
                    {deleteShipIsBusy &&<i className="li-pointer li-fg-primary fa fa-spinner fa-pulse fa-fw"/>}
                    {!deleteShipIsBusy && showDeleteIfAllowed()} &nbsp;
                    {!deleteShipIsBusy && showAllowShipNowIfAllowed()}
                </td>
                {showExportButtonIfRequired()}
                <td className="text-center">{LIUtils.dateTimeToPretty(dateStarted)}</td>
                <td>{requestedBy.fullName}</td>
                <td>{createdBy.fullName}</td>
                <td>{dumpDestination()}</td>
                <td style={{whiteSpace: 'pre-line'}}>{notes}</td>
            </tr>
    );
}

export default BTOCardRow;